export const RatingsStyles = {
  RatingsWrapper: {
    Rating:{
      color: 'primary',
      marginX: 1,
    }
  }
}
